import { Component } from '@angular/core';
import { SalesDashboardComponent } from '../sales-dashboard/sales-dashboard.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';

@Component({
  selector: 'app-all-leads',
  imports: [
    SalesDashboardComponent,
    AdminDashboardComponent
  ],
  templateUrl: './all-leads.component.html',
  styleUrls: ['../styles/leads.css', './all-leads.component.css']
})
export class AllLeadsComponent {

  loggedInUser: any;
  userDepartment: any;
  loggedInUserName: any;
  assistantUser: any;

  ngOnInit() {
    this.userDepartment = localStorage.getItem('department');
    this.loggedInUser = this.userDepartment === 'ADMIN' || this.userDepartment === 'MARKETING';
    this.assistantUser = this.userDepartment === 'ASSISTANT-SALES';
    this.loggedInUserName = localStorage.getItem('username');
  }
}
